import { ContextualWarning } from 'common/contextual-warning/contextual-warning.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { BeltSwiper } from 'components-modules/belt/belt-swiper.js';
import { ImageTileCompact } from 'components-modules/belt/image-tile-compact.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { IModule } from 'redux-state/layout/types.js';

interface IBeltItem {
  title: string;
  url: string;
  image: string;
}

export interface IBeltConfig {
  name: string;
  items: Array<IBeltItem>;
  itemsMobile?: Array<IBeltItem>;
}

export const BeltModule = (props: IModule<IBeltConfig>) => {
  const isLarge = useContext(ColumnLayoutContext) !== '1-column';
  return <BeltCore {...props} isLarge={isLarge} />;
};

const BeltCore = ({ config, isLarge, modulePath, isDrawer }: IModule<IBeltConfig> & { isLarge: boolean }) => {
  const { items, itemsMobile, maintenance, hideContentOnMaintenance } = config;

  const showContent = !maintenance || hideContentOnMaintenance === false;

  let mobileImages = itemsMobile || [];
  // Fallback if mobileImages isn't provided
  if (!mobileImages || mobileImages.length === 0) {
    mobileImages = items;
  }

  if (isLarge) {
    return (
      <Tile dataModule="belt" config={config}>
        <div className="Tile-body">
          <TileBodyHeaderV2 isDrawer={isDrawer} modulePath={modulePath} config={config} />
          {/* Tablet upwards, show swiper */}
          <BeltSwiper items={items} />
        </div>
      </Tile>
    );
  }
  return (
    <div data-module-name="belt">
      {/* Belt at mobile is a special case and cannot use the Tile wrapper, so maintenance warning needs to be included here */}
      {maintenance && (
        <div className="u-pB-sm">
          <ContextualWarning maintenance={maintenance} />
        </div>
      )}
      {showContent && (
        // Mobile only, show items as individual tiles
        <ImageTileCompact items={mobileImages} />
      )}
    </div>
  );
};
